/**
 * Sim-lab ambient audio — curated tracks + presets.
 * Docs: docs/SIM_LAB_AMBIENT_AUDIO.md
 */

/** @typedef {{ id: 'surf' | 'wind' | 'gulls', label: string, description: string }} AmbientTrack */

/** @type {AmbientTrack[]} */
export const AMBIENT_TRACKS = [
  { id: 'surf', label: 'surf', description: 'Ocean swell + swash' },
  { id: 'wind', label: 'wind', description: 'Coastal breeze with gusts' },
  { id: 'gulls', label: 'gulls', description: 'Sparse distant gull cries' },
];

/**
 * @typedef {Object} AmbientPreset
 * @property {string} id
 * @property {string} label
 * @property {Record<string, number>} tracks - 0..1 per track id
 */

/** @type {AmbientPreset[]} */
export const AMBIENT_PRESETS = [
  {
    id: 'beach-day',
    label: 'beach · day',
    tracks: { surf: 0.7, wind: 0.35, gulls: 0.22 },
  },
  {
    id: 'beach-calm',
    label: 'beach · calm',
    tracks: { surf: 0.45, wind: 0.18, gulls: 0.08 },
  },
  {
    id: 'breeze-only',
    label: 'breeze',
    tracks: { surf: 0, wind: 0.4, gulls: 0 },
  },
  {
    id: 'off',
    label: 'silence',
    tracks: { surf: 0, wind: 0, gulls: 0 },
  },
];

const presetById = new Map(AMBIENT_PRESETS.map((p) => [p.id, p]));

export function getAmbientPreset(id) {
  return presetById.get(id) || presetById.get('off');
}

/** Auto preset when an exterior env is selected. */
export function defaultAmbientPresetForExterior(exteriorId) {
  if (exteriorId === 'beach') return 'beach-day';
  return 'off';
}
